import { InjectionToken } from "@angular/core";
export const PARENT_TABLE = /*#__PURE__*/new InjectionToken('Parent Table');
export const PARENT_TABLE_BODY = /*#__PURE__*/new InjectionToken('Parent Table Body');